import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import cars from "../../assets/images/cars.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
import "../fahrzeugübersicht/Fahrzeugübersicht.css";
import HeroSection from "../heroSection/HeroSection";
import VehicleSection from "../vehicleSection/VehicleSection";
import "./Speditionsversand.css";
import VersandInfoCards from "./versandInfos";
import Koeriersvoertuigen from "./Koeriersvoertuigen";
import TransCiroxSpeditionsversand from "./TransCitoSpeditionsversand";
import RundläufeTransCirox from "./RundläufeTransCito";
import Footer from "../footer/Footer";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SEO from "../SEO";

const Speditionsversand = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const features = t("Speditionsversand.features", { returnObjects: true });

  return (
    <>
      <SEO
        title="TransCirox – Speditionsversand | Güter & Palettenversand günstig"
        description="Professioneller Speditionsversand für Güter und Paletten. TransCirox bietet zuverlässige Speditionsdienstleistungen für Privat- und Geschäftskunden in ganz Deutschland."
        keywords="Speditionsversand, Palettenversand, Güterversand, Spedition günstig, Frachttransport, Logistik, Gütertransport, Palettentransport, Transport Preise"
      />
      <HeroSection
        backgroundImage={cars}
        // title={t("Speditionsversand.hero_titler")}
        titleHighlight={t("Speditionsversand.hero_title")}
        features={Array.isArray(features) ? features : []}
        showQuoteForm={false}
        showCTAButton={true}
        ctaText={t("Speditionsversand.button")}
        ctaRoute="/register/client"
        formType="speditionsversand"
      />

      <section className="service-section py-5 bg-light">
        <VersandInfoCards />
        <Koeriersvoertuigen />
        <TransCiroxSpeditionsversand />
        <RundläufeTransCirox />
      </section>

      <Footer />
    </>
  );
};

export default Speditionsversand;
